export const CHAT_BOTTOM_THRESHOLD = 100

interface ScrollMetrics {
  scrollTop: number
  scrollHeight: number
  clientHeight: number
}

export interface ChatScrollAnchor {
  distanceFromBottom: number
  wasAtBottom: boolean
}

export function getChatScrollAnchor(metrics: ScrollMetrics): ChatScrollAnchor {
  const distanceFromBottom = Math.max(
    0,
    metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight,
  )

  return {
    distanceFromBottom,
    wasAtBottom: distanceFromBottom < CHAT_BOTTOM_THRESHOLD,
  }
}

export function getRestoredScrollTop(
  scrollHeight: number,
  clientHeight: number,
  anchor: ChatScrollAnchor,
): number {
  if (anchor.wasAtBottom) return scrollHeight
  return Math.max(0, scrollHeight - clientHeight - anchor.distanceFromBottom)
}

export function getPrependedScrollTop(
  previousScrollTop: number,
  previousScrollHeight: number,
  newScrollHeight: number,
): number {
  return previousScrollTop + Math.max(0, newScrollHeight - previousScrollHeight)
}
